<template>
    <section v-if="hasPermissions(['Options-Time-Off Read', 'Options-Time-Off Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of the Time Off types for your facility.  To add a Time Off type, click Add Time Off. Enter a description and click Save.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="time_off.length && hasPermissions(['Options-Time-Off Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Options-Time-Off Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="time_off.length  && hasPermissions(['Options-Time-Off Read'])">
            <div class="tab-pane fade" id="cards-listation">
                <div class="row mb-0">
                    <div class="col-sm-6 col-lg-3" v-for="(value, i) in time_off" :key="i">
                        <div class="row mb-0 no-gutters h-100">
                            <div class="col-12 card cardList hoverable">
                                <div class="card-content h-100">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <div v-if="has_permission('Options-Time-Off Read-Write')">
                                                    <a href="#" @click="modal_update(i)" class="textTitleCard">
                                                         {{ `${i+1}. ${value.description}` }}
                                                    </a>
                                                </div>
                                                <div v-else>
                                                    <a href="#" class="textTitleCard">
                                                         {{ `${i+1}. ${value.description}` }}
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-if="has_permission('Options-Time-Off Read-Write')" class="col-2 text-right">
                                                <a href="#" @click="modal_deletion(i)">
                                                    <i class="material-icons prefix ">
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-12">
                                            <ul class="list">
                                                <li v-html="`Description: ${value.description}`" class="list__item"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-action right-align">
                                    <a :href="`#`" class="card-action__link">
                                        View more
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="time_off"
                                :search="search"
                                :checkable="true"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            >
                            </DinamicTable>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Time Off'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Time Off Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios            from    'axios';
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import Resources        from    './resources'
import FormModal        from    './FormModal'
import UpdateModal      from    './UpdateModal'
import DinamicTable             from    '@/components/DinamicTable'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'TimeOff',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionMassiveModal,
        FormModal,
        UpdateModal,
        UnauthorizedComponent,
        DinamicTable
    },

    data() {
         return {
            notyf,
            axios,
            user:               this.get_user(),
            title_page:         'Time Off',
            rest_api:           `time_off`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add Time Off',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            time_off:           [],
            array_options:      {},
        }
    },
    methods: {

        unshift_object(new_object)
        {
            this.time_off.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.time_off.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        massive_modal_delete()
        {
            this.select_ids = this.time_off.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let sendingMassive = await this.massive_delete({ ids: this.select_ids })

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.time_off.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.time_off.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.time_off[index]
            
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.time_off = data.time_off
        },

        trashing(index)
        {
            this.time_off.splice(index, 1)
        }
    },

    async mounted()
    {
        if(this.hasPermissions(['Options-Time-Off Read']))
        {
            await this.api_request()
        }
    },
     computed:
    {
         selected()
        {
            const bool = this.time_off.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>
